import { message } from 'antd';
import { dateTimeFormatMap, dateFormatMap } from './config';
import { FormatMoney } from '@/utils';
import { formatLocalTime } from '@/utils/timeConversionTool';
import gtm from '@/utils/gtm';

export function showErrorMessage(code: string, t: any) {
    // 积分不足
    if (code === '2418') {
        message.error(t('no_enough_points'));
        return;
    }

    // 前端页面长时间不刷新，导致兑换规则落后后端版本
    if (code === '2422') {
        message.error(t('stay_too_long'));
        return;
    }

    // 兑换次数超出上限
    if (code === '2423') {
        message.error(t('exceeded_counts'));
        return;
    }

    // 前端页面长时间不刷新，导致优惠券规则超过截止时间
    if (code === '2424') {
        message.error(t('stay_too_long'));
        return;
    }

    // 库存不足
    if (code === '2426') {
        message.error(t('no_stock_tip'));
        return;
    }

    // 库存不足
    if (code === '2429') {
        message.error(t('no_stock_tip'));
        return;
    }

    // 活动未开始
    if (code === '2430') {
        message.error(t('active_is_unstart'));
        return;
    }

    // 活动已结束
    if (code === '2431') {
        message.error(t('active_is_ended'));
        return;
    }

    // 活动被禁用
    if (code === '2432') {
        message.error(t('active_is_ended'));
        return;
    }

    // 超出兑换次数
    if (code === '2433') {
        message.error(t('over_max_count'));
        return;
    }

    // 抽中券，但是券过期的情况
    if (code === '2434') {
        message.error(t('active_is_ended'));
        return;
    }

    message.error(t('stay_too_long'));
}

// 给coupon添加Notes
export const injectNotes = (coupon: any[], t: any, locale: string, timezoneList?: any) => {
    return coupon?.map((coupon: any) => {
        const noteList: string[] = [t('site_rules'), t('order_rule')];
        // 不找零
        if (coupon?.prerequisite !== 'PRICES' && coupon?.discountType === 'fixed_amount') {
            noteList.push(t('purchas_rule'));
        }
        if (coupon?.prerequisite === 'PRICES' && coupon?.discountType === 'fixed_amount') {
            const couponPrice = parseInt(coupon?.amount);
            const priceRange = parseInt(coupon.prerequisiteRange);
            if (priceRange < couponPrice) {
                noteList.push(t('purchas_rule'));
            }
        }
        if (coupon?.goodId) noteList.push(t('product_rules', { product: coupon?.goodTitle || '' }));

        // 最低金额
        if (coupon?.prerequisite === 'PRICES') {
            const price = parseInt(coupon.prerequisiteRange);
            const currencySymbol = coupon?.currencySymbol || '';
            const prerequisiteRange = t('minimum_price', { price: currencySymbol + FormatMoney(price) });
            noteList.push(prerequisiteRange);
        }

        // 最低数量
        if (coupon?.prerequisite === 'QUANTITY') {
            const num = parseInt(coupon.prerequisiteRange);
            const prerequisiteRange = t('minimum_num', { num });
            noteList.push(prerequisiteRange);
        }

        // 过期天数
        const limitDay = Math.floor((coupon?.expiredDay || 0) / 60 / 24);
        if (coupon?.expiredFlag && coupon?.expiredType === 'DAY') {
            noteList.push(t('days_rules', { days: limitDay }));
        }
        // 时间 for 福利中心
        if (coupon?.couponId && coupon?.endTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            // const startTime = moment(Number(coupon?.startTime)).format(formater);
            // const endTime = moment(Number(coupon?.endTime)).format(formater);
            const startTime = formatLocalTime(coupon?.startTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.endTime, timezoneList, formater);
            noteList.push(t('days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // 时间 for 优惠券
        if (coupon?.coupon && coupon?.endTime) {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            // const startTime = moment(Number(coupon?.startTime)).format(formater);
            // const endTime = moment(Number(coupon?.endTime)).format(formater);
            const startTime = formatLocalTime(coupon?.startTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.endTime, timezoneList, formater);
            noteList.push(t('days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // 时间 for 优惠券规则
        if (!(coupon?.coupon || coupon?.couponId) && coupon?.expiredFlag && coupon?.validEndTime && coupon?.expiredType === 'TIME') {
            const formater = dateTimeFormatMap[locale as string] || dateTimeFormatMap['us'];
            // const startTime = moment(Number(coupon?.validStartTime)).format(formater);
            // const endTime = moment(Number(coupon?.validEndTime)).format(formater);
            const startTime = formatLocalTime(coupon?.validStartTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.validEndTime, timezoneList, formater);
            noteList.push(t('days_rules2', { data: `${startTime}-${endTime}` }));
        }

        // campaign限时型时间
        if (!coupon?.discountId && coupon?.campaignStartTime && coupon?.campaignEndTime) {
            const formater = dateFormatMap[locale as string] || dateFormatMap['us'];
            // const startTime = moment(Number(coupon?.campaignStartTime)).format(formater);
            // const endTime = moment(Number(coupon?.campaignEndTime)).format(formater);
            const startTime = formatLocalTime(coupon?.campaignStartTime, timezoneList, formater);
            const endTime = formatLocalTime(coupon?.campaignEndTime, timezoneList, formater);
            noteList.push(t('campaign_time_limit_text', { startTime, endTime }));
        }
        // 临时新增规则 只针对这一个优惠券
        if (coupon?.discountId && coupon?.discountId === '1698949120957939713') {
            noteList.push('*단순 개봉 제품');
        }
        if (coupon?.extRuleDesc) {
            noteList.push(coupon?.extRuleDesc);
        }
        return { ...coupon, showMore: false, noteList };
    });
};

/**
 * 低仿t函数
 * @param textLang 文案json 类似 member-luckyturntable/content/textLang.ts
 * @param locale
 * @returns t
 */
export const getLang = (textLang: Record<string, Record<string, any>>, locale: string) => {
    const lang = textLang[locale] || textLang.us;
    const t = (key: string, options?: { [key: string]: string }): string => {
        if (options) {
            let str = t(key);
            Object.keys(options).map((key) => {
                str = str.replaceAll(`{${key}}`, options[key]);
            });
            return str;
        }
        return lang[key] ?? key;
    };
    t.rich = (
        key: string,
        options: { [key: string]: ((children?: string) => string | React.ReactNode) | string | number },
    ): Array<string | React.ReactNode> => {
        let str = t(key);
        const childrenObj: Record<string, string> = {};
        Object.keys(options).map((key) => {
            const regex = new RegExp(`<${key}[^>]*>(.*?)</${key}>`, 'gi'); // <key></key>格式的
            const regex2 = new RegExp(`{${key}}`, 'gi'); // {key}格式的
            str = str.replace(regex2, options[key] as string);
            // 匹配标签与其中文案
            str = str.replace(regex, (match, p1) => {
                if (match) childrenObj[key] = p1;
                return `#${key}#`; // 返回文本内容，替换掉整个标签
            });
            // 暂存的标签中字符串也要check一遍～
            Object.keys(childrenObj).map((ckey) => (childrenObj[ckey] = childrenObj[ckey].replace(regex2, options[key] as string)));
        });
        const arr = str.split('#').map((item) => (options[item] ? (options[item] as (children?: string) => string)(childrenObj[item]) : item));
        return arr;
    };
    return t;
};

// 埋点
type TrackItem = {
    /** 按钮链接 */
    btnHref: string;
    /** 按钮文案 */
    btnText: string;
    /** 按钮标题 */
    title: string;
};
export const handleTrack = (item: TrackItem, title: string) => {
    const href = item.btnHref;
    let curGtm;
    if (/^(?:[a-z]+\.)?ecoflow\.com\/checkouts$/.test(href)) {
        // 跳结算页
        curGtm = {
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: `${item.btnText}_${item.title}`,
        };
    } else if (href.includes('www.ecoflow.com')) {
        // 跳官网
        curGtm = {
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: title,
            product_name: item.title,
            button_name: item.btnText,
        };
    } else if (/^(?:[a-z]+\.)?ecoflow\.com$/.test(href)) {
        // 跳 shopify
        curGtm = {
            event: 'uaEvent',
            event_name: 'buy',
            product_name: item.title,
            position: title,
        };
    } else {
        // 其他
        curGtm = {
            event: 'uaEvent',
            event_name: 'jump_button',
            position: 'Inpage',
            button_name: item.btnText,
            url: item.btnHref,
        };
    }
    gtm.push(curGtm);
};

/**
 * 积分数位符格式化
 * @param points
 * @param locale
 * @returns
 */
export const formatPointsByLocale = (points: number | string | undefined | null, locale: string): string => {
    if (!points && points !== 0) return '';
    const pointsArr = points.toString().split('.');
    let integerPart = pointsArr[0];
    const decimalPart = pointsArr[1];
    let thousandSeparator = ',',
        decimalSeparator = '.';

    switch (locale) {
        case 'es':
            thousandSeparator = '\u00A0';
            if (parseInt(integerPart) < 10000) {
                return decimalPart ? `${integerPart}${decimalSeparator}${decimalPart}` : integerPart;
            }
            break;
        case 'it':
        case 'br':
            thousandSeparator = '.';
            decimalSeparator = ',';
            break;
        case 'de':
        case 'fr':
            thousandSeparator = '\u00A0';
            decimalSeparator = ',';
            break;
        default:
            break;
    }

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

    return decimalPart ? `${integerPart}${decimalSeparator}${decimalPart}` : integerPart;
};
